import {
  Stethoscope,
  Syringe,
  ShieldCheck,
  FlaskConical,
  Scissors,
  HeartPulse,
} from "lucide-react";

const services = [
  {
    icon: Stethoscope,
    title: "Medicina general",
    description:
      "Consultas completas para el diagnóstico y tratamiento de cualquier patología.",
  },
  {
    icon: Syringe,
    title: "Vacunación",
    description:
      "Protocolos de vacunación actualizados para cachorros, adultos y gatos.",
  },
  {
    icon: ShieldCheck,
    title: "Desparasitación",
    description:
      "Tratamientos internos y externos adaptados a cada especie y estilo de vida.",
  },
  {
    icon: FlaskConical,
    title: "Analíticas básicas",
    description:
      "Hemogramas, bioquímicas y análisis de orina con resultados rápidos.",
  },
  {
    icon: Scissors,
    title: "Cirugía programada",
    description:
      "Esterilizaciones, limpiezas dentales y cirugías menores con seguimiento.",
  },
  {
    icon: HeartPulse,
    title: "Planes preventivos",
    description:
      "Programas de salud anuales para mantener a tu mascota siempre protegida.",
  },
];

export const ServicesSection = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="py-20 md:py-28 bg-muted/40"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-14 md:mb-20">
          <span className="text-sm font-medium tracking-wide uppercase text-primary/80 mb-3 block">
            Nuestros servicios
          </span>
          <h2
            data-testid="services-title"
            className="text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4"
          >
            Cuidado integral para tu mascota
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-lg mx-auto">
            Desde revisiones rutinarias hasta cirugías programadas, cubrimos
            todas las necesidades de salud de tu compañero.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                data-testid={`service-card-${index}`}
                className="group bg-white rounded-2xl p-8 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_40px_-10px_rgba(0,0,0,0.1)] border border-border/40 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-secondary flex items-center justify-center mb-5 group-hover:bg-primary/10 transition-colors">
                  <Icon
                    className="w-5 h-5 text-primary"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2 tracking-tight">
                  {service.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
